import { IFormField, IFormFieldRenderer } from '@migrate/utils/form/form'
import renderDate from '@migrate/utils/renderer/Date'

export class DateRenderer implements IFormFieldRenderer {
  render(field: IFormField) {
    return renderDate(field.value)
  }
}
